'use client'

import * as React from 'react'
import { createIcon } from '../utils'

const ThumbsUpIcon = createIcon({
    displayName: 'ThumbsUpIcon',
    viewBox: '0 0 19 19',
    fill: 'none',
    path: (
        <path
            d="M5.25016 17.8337V8.66699M1.0835 10.3337V16.167C1.0835 17.0875 1.82969 17.8337 2.75016 17.8337H13.9387C15.1726 17.8337 16.222 16.9334 16.4096 15.7138L17.3071 9.88047C17.54 8.36607 16.3683 7.00033 14.8361 7.00033H11.9168C11.4566 7.00033 11.0835 6.62723 11.0835 6.16699V3.22186C11.0835 2.08699 10.1635 1.16699 9.02863 1.16699C8.75794 1.16699 8.51265 1.3264 8.40271 1.57376L5.47011 8.17211C5.33636 8.47305 5.03793 8.66699 4.7086 8.66699H2.75016C1.82969 8.66699 1.0835 9.41318 1.0835 10.3337Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    ),
})

export default ThumbsUpIcon
